import { downloadAsZip } from '../actions/downlaod_zip'
import { toggleItemLoading } from '../render/item_loading'

type DownloadAsset = {
    url: string
    name: string
}

function globalHandler(item: Element) {
    //Asset URLs
    const assetElements = document.querySelectorAll('[download-type="asset"]')
    const assets: DownloadAsset[] = []

    assetElements.forEach((assetElement) => {
        const url = assetElement.getAttribute('src')
        const name = assetElement.getAttribute('name') || 'Unnamed Asset - ARKEN'
        if (url) {
            assets.push({ url, name })
        }
    })

    //image URLs
    const imageElements = document.querySelectorAll('[download-item="image"]')
    const images: DownloadAsset[] = []
    imageElements.forEach((imageElement) => {
        const url = imageElement.getAttribute('imgsrc') || imageElement.getAttribute('fallback')
        const name = imageElement.getAttribute('name') || 'Unnamed Image - ARKEN'
        if (url) {
            images.push({ url, name })
        }
    })

    console.log('Assets to download:', assets)
    console.log('Images to download:', images)

    toggleItemLoading(item, true)
    downloadAsZip(item, [...assets, ...images], 'arken_presskit')
}

export { globalHandler }
